module.exports = __webpack_public_path__ + "static/media/video.d1d327ad.svg";